import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/app/frontend/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/app/frontend/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "frontend"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/app.43fa64d4.css",
    "revision": null
  },
  {
    "url": "/img/lidarr.svg",
    "revision": "90152157249538a77c9d6ac8bbb023e8"
  },
  {
    "url": "/img/nzbget.svg",
    "revision": "fead92bb9d13415f9260e4ffa5e43b4c"
  },
  {
    "url": "/img/prowlarr.svg",
    "revision": "b8e7ddcc045256184f42ee1ae2290f40"
  },
  {
    "url": "/img/radarr.svg",
    "revision": "2802633ef4591d5f6d4e30db70cb94fd"
  },
  {
    "url": "/img/sabnzbd.svg",
    "revision": "c7262a5de1c67dde7c5776fc17533eb2"
  },
  {
    "url": "/img/sonarr.svg",
    "revision": "15a2e6743eeb3d808a03508a2b1418f4"
  },
  {
    "url": "/index.html",
    "revision": "af821513fa39429024759b1cc64e9688"
  },
  {
    "url": "/iplayarr.png",
    "revision": "d5c0408e6fa8905c51be1cd18798a3f5"
  },
  {
    "url": "/js/app.7b572f65.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "68d83efa7b32c92c66e953ca186badc2"
  },
  {
    "url": "/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  },
  {
    "url": "/shortcuts/Download With iPlayarr.shortcut",
    "revision": "3e700f4e6766f9542885fe3400d428f6"
  }
], {});








